import { useState } from 'react';
import { Tag } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { useUpdateClinicTopic } from '@/hooks/coach/use-coach-sessions';

interface ClinicTopicProps {
  sessionId: string;
  initialTopic: string;
}

export function ClinicTopic({ sessionId, initialTopic }: ClinicTopicProps) {
  const [value, setValue] = useState(initialTopic);
  const [saved, setSaved] = useState(false);
  const { mutateAsync, isPending } = useUpdateClinicTopic(sessionId);

  const handleBlur = async () => {
    if (value === initialTopic) return;
    await mutateAsync(value);
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <Tag className="w-4 h-4" />
          Clinic Topic / Theme
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="relative">
          <Input
            placeholder="e.g. Serve mechanics, Doubles tactics, Net play..."
            value={value}
            onChange={(e) => { setValue(e.target.value); setSaved(false); }}
            onBlur={handleBlur}
            disabled={isPending}
          />
          {saved && (
            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-green-600">
              Saved
            </span>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
